import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

// Interfaces
import { ICompany } from 'src/app/entities/interfaces/configuration/ICompany';

@Injectable({
    providedIn: 'root'
})
export class CompanyService {

    constructor(private http: HttpClient) { }

    private getHeaders(): HttpHeaders {
        const token: string = sessionStorage.token;
        return new HttpHeaders({ 'Authorization': token });
    }

    // ─── List (GET) ─────────────────────────
    List(): Observable<any> {
        const headers = this.getHeaders();
        const uri = environment.pathBackEnd.concat("company/List.php");
        return this.http.get<any>(uri, { headers });
    }

    // ─── GetData (GET) — legacy ─────────────
    GetData(): Observable<any> {
        const headers = this.getHeaders();
        const uri = environment.pathBackEnd.concat("company/GetData.php");
        return this.http.get<any>(uri, { headers });
    }

    /** Swagger: PUT /company/Create.php (cambió de POST a PUT) */
    Create(row: { idCompany: string; businessName: string; adminPassword: string }): Observable<any> {
        const headers = this.getHeaders();
        const uri = environment.pathBackEnd.concat("company/Create.php");
        return this.http.put<any>(uri, row, { headers });
    }

    // ─── Update (PUT) ──────────────────────
    Update(row: ICompany): Observable<any> {
        const headers = this.getHeaders();
        const uri = environment.pathBackEnd.concat("company/Update.php");
        return this.http.put<any>(uri, row, { headers });
    }

    // ─── Delete (POST) ─────────────────────
    Delete(idCompany: string): Observable<any> {
        const headers = this.getHeaders();
        const uri = environment.pathBackEnd.concat("company/Delete.php");
        return this.http.post<any>(uri, { idCompany }, { headers });
    }
}
